import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import HireExpertListings from "./FilterandHireExperts/HireExpertListings";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import FilterAll from "../FindWork/FilterAll/FilterAll";
import { getFilterwithcategory } from "../../../redux/filter/action";
import OTSSearch from "../../Common/Search/OTSSearch";
import { useAllFilterBaseContext } from "../../../Context/AllFilterBaseContext";

export default function FilterandHireExperts() {
  const path = "Assets/scss/hireexpert.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const { state, setSearch, } = useAllFilterBaseContext();
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const [totalandsize, setTotalandsize] = useState({
    total: 0,
    size: 0,
  });

  const location = useLocation();
  const indcatsub = location?.state?.indcatsub;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFilterwithcategory(2, indcatsub?.category_id));
  }, []);


  return (
    <div className="hire-details col-lg-10 mx-auto">
      <p className="breadcrumbs">
        <a
          onClick={() =>
            navigate(`/${lan}/hireexpertsbycategory/${indcatsub?.industry_id}`)
          }
        >
          {indcatsub?.industry_name} &gt;
        </a>
        {indcatsub?.subcategory_name ? (
          <>
            {" "}
            <a>{indcatsub?.category_name} &gt;</a> {indcatsub?.subcategory_name}
          </>
        ) : (
          <> {indcatsub?.category_name} </>
        )}
      </p>
      <div className="hire-detail-first">
        <h2>
          Hire the best{" "}
          <span>
            {" "}
            {indcatsub?.subcategory_name ? (
              <> {indcatsub?.subcategory_name}</>
            ) : (
              <> {indcatsub?.category_name} </>
            )}
          </span>{" "}
          Experts / Company
        </h2>
        <p>
          Viewing{" "}
          {(() => {
            const start = totalandsize?.index * totalandsize?.size + 1;
            let end = (totalandsize?.index + 1) * totalandsize?.size;

            if (end > totalandsize?.total) end = totalandsize?.total;

            return `${start}–${end}`;
          })()}{" "}
          of {totalandsize?.total} designers available for hire
        </p>

      </div>
      <div className="search-bar" style={{ width: "60%" }}>
        <OTSSearch
          state={state}
          setSearch={setSearch}
          placeholder={`Search Experts / Company`}
        />
      </div>
      <div className="row">
        <div className="col-lg-3 col-md-4">
          <FilterAll />
        </div>
        <div className="col-lg-9 col-md-8">
          <HireExpertListings setTotalandsize={setTotalandsize} />
        </div>
      </div>
    </div>
  );
}
